// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import BreadcrumbNav from '../../nav/BreadcrumbNav';
import Console from '../../../lib/debug';

class MyStore extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    getPageTitle = () => {
        let title =
            this.props.metaTree &&
            this.props.metaTree.instances &&
            this.props.metaTree.instances[this.pageKey] &&
            this.props.metaTree.instances[this.pageKey].title;
        if (title) {
            return title;
        }
        return '';
    };

    render() {
        Console.render(`${this.pageKey} View`);
        const crumbs = [
            {
                displayString: this.props.pageKey,
                link: this.props.link,
                editable: false
            }
        ];
        return (
            <main className="thmp-mystore-main">
                <Container maxWidth="lg">
                    <Grid justify="center" container>
                        <Grid xs={12} item>
                            {this.props.useHeaderImage ? (
                                <div className="thmp-mystore-header">
                                    <div
                                        className={this.props.headerClassName}
                                    />
                                    <div>
                                        <h1 className="thmp-mystore-h1">
                                            {this.props.pageTitle}
                                        </h1>
                                        <p className="thmp-mystore-intro">
                                            {this.props.pageIntro}
                                            <a href="/my-store/analytics/attributions">
                                                Attributions&nbsp;Report.
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <h1 className="thmp-mystore-h1">
                                    {this.props.pageTitle}
                                </h1>
                            )}
                        </Grid>
                    </Grid>
                    <Grid justify="center" container>
                        <Grid xs={12} item>
                            <BreadcrumbNav crumbs={crumbs} />
                            {this.props.children}
                        </Grid>
                    </Grid>
                </Container>
            </main>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        metaTree: state.app.metaTree
    };
};

export default connect(mapStateToProps)(MyStore);



// WEBPACK FOOTER //
// ./src/view/my-store/components/MyStore.js